import React from "react";

const Building = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M3 21H12M9 8H10M9 12H10M9 16H10M14 8H15M14 12H15M5 21V5C5 4.47 5.211 3.961 5.586 3.586C5.961 3.211 6.47 3 7 3H17C17.53 3 18.039 3.211 18.414 3.586C18.789 3.961 19 4.47 19 5V12M16 19H22M19 16V22" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    )
}

export default Building;